import React, {useEffect} from 'react'

import BasePage from "../../Components/BasePage/BasePage";
import coubertin from '../../Assets/Logos/coubertin.svg'
import plenitude from '../../Assets/Logos/plenitude.svg'
//import matmut from '../../Assets/Logos/matmut.svg'
import bordeaux from '../../Assets/Logos/bordeaux.png'
import mauroy from '../../Assets/Logos/losc.png'
import parisSaintGermain from '../../Assets/Logos/parisSaintGermain.svg'
import rolandGarros from '../../Assets/Logos/rolandGarros.svg'
import './HomePage.scss'
import {useNavigate} from "react-router-dom";
import {clearState} from "../../store/actions";
import {useDispatch} from "react-redux";

interface StadeModel {
    image: string,
    reference: string
    width?: string
    height?: string
}

const stades: StadeModel[] = [
    {image: coubertin, reference: 'PDC'},
    {image: plenitude, reference: 'PAR', height: '150%'},
    {image: bordeaux, reference: 'BMA', height: '90%'},
    {image: mauroy, reference: 'LIL', height: '100%'},
    {image: parisSaintGermain, reference: 'PDP', height: '90%'},
    {image: rolandGarros, reference: 'RGP', width: '40%'},
]

const HomePage: React.FC = ({}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(clearState())
    }, [])

    return (
        <BasePage showLogo showHistorique>
            <div className="stadesContainer">
                {
                    stades.map((stade, index) => (
                        <div key={index} className="stadesContainer__stade" onClick={() => navigate(`/${stade.reference}`)}>
                            <img src={stade.image} alt={stade.reference} style={{width: stade.width, height: stade.height}} />
                        </div>
                    ))
                }
            </div>
        </BasePage>
    )
}

export default HomePage;
